<template lang='pug'>
  bionic-metrics-page-loading
</template>

<script>
import {mapActions} from 'vuex';
import Notifications from '../services/notification.service';
import BionicMetricsSpinner from '../components/Spinner';
import External from '../api/external';
import BionicMetricsPageLoading from '../components/PageLoading';

export default {
  components: {BionicMetricsPageLoading, BionicMetricsSpinner},
  name: 'Activate',
  props: ['token'],
  async created() {
    if (!this.token) {
      return this.$router.push('/signin');
    }
    try {
      const user = (await External.activate(this.token)).data;
      await this.setUser(user);
      Notifications.toast('Email Address Confirmed Successfully');
      return this.$router.push('/');
    } catch (err) {
      console.error(err);
      Notifications.alert('Invalid token. Redirecting.').then(this.abort);
    }
    return true;
  },
  methods: {
    abort() {
      this.$router.push('/');
    },
    ...mapActions({
      setUser: 'setUser'
    })
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
